import type { FaireThemeEntity } from "../../entity_types/theme";

export const clean_beauty_discovery: FaireThemeEntity = {
  token: "clean-beauty-discovery",
  type: "theme",
  name: "Clean Beauty Discovery",
  description: "Organic, vegan, and non-toxic makeup kits -- perfect for adding a curated beauty counter to a pop-up.",
  teaser: "Add a beauty counter to your pop-up with organic discovery kits.",
  detail: "Your natural ingredients, vegan, and non-toxic signals plus frequent orders of healing salves and aromatherapy mists make these a natural brand extension. Built around River Organics Lip Discovery Kit and Taylor Made Organics Liquid Mineral Foundation.",
  bgColor: "#F0D4C4",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_b9r6q9pgxk",
    "p_n84dby9hq5",
    "p_mdzwes5fgm",
    "p_d5ym8r46qx",
    "p_6gw9wr3wv9",
    "p_h7chgnadmg",
    "p_7xc38yc6gq",
    "p_4w7a6pw4dz",
    "p_42n546c9et",
    "p_e8b6rxq4x3",
    "p_3zruhwc4pc",
    "p_m6akt3hnb3",
    "p_tvjqzy4zr2",
    "p_acvsk4nwej",
    "p_b2nb2x6uqr",
    "p_3prhvv97tc",
    "p_dhngknqnc9",
    "p_rhr7pqr45x",
    "p_b5fs9zu4jv",
    "p_zejradg8bh",
    "p_sqz7h9bnaj",
    "p_z7fezkg54k",
    "p_cyxrudx2uw",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
